import { SocketBase } from "./socket-base";

export default SocketBase;
